export default __webpack_public_path__ + "static/media/GreenLake_Demos_old.88bac217.jpeg";